import React from 'react';
import cn from 'classnames';

import type { TSkeleton } from './models';

export const Skeleton = ({ SkeletonUI, isMobile, rowsCount = 3, styles }: TSkeleton) => {
    return (
        <tbody className={styles.skeleton}>
            {Array.from({ length: rowsCount }, (_, index) => (
                <tr
                    key={index}
                    className={cn(styles.row, styles.borderLine, {
                        [styles.firstBorderLineMobile]: isMobile,
                    })}
                >
                    <td className={cn(styles.external, styles.firstColumn)}>
                        <SkeletonUI
                            borderRadius={12}
                            className={styles.skeletonCircle}
                            height={24}
                            styler={{ marginRight: 8 }}
                            width={24}
                        />
                        <SkeletonUI borderRadius={8} className={styles.skeletonStrip} height={24} />
                    </td>
                    <td align="right" className={cn(styles.external, styles.restColumn)}>
                        <SkeletonUI borderRadius={8} className={styles.skeletonStrip} height={24} />
                    </td>
                    <td align="right" className={cn(styles.external, styles.restColumn)}>
                        <SkeletonUI borderRadius={8} className={styles.skeletonStrip} height={24} />
                    </td>
                </tr>
            ))}
        </tbody>
    );
};
